/**
 * Keep prior active payload only while the account stays the same.
 * Cross-email reuse would flash the previous user's Top 3 / names.
 * queryKey shape: ['sea-tracking', 'active', email, importer, exporter]
 */
export const keepActivePlaceholder = (prev, prevQuery, email = '') => {
  if (prev == null || !prevQuery) return undefined;
  const prevEmail = prevQuery.queryKey?.[2] ?? '';
  if (prevEmail !== (email || '')) return undefined;
  return prev;
};
